import { create } from 'zustand'
import { subscribeWithSelector } from 'zustand/middleware'

export const useStore = create(
  subscribeWithSelector(set => ({
    // Global Settings
    prevPath: null,
    setPrevPath: prevPath => set({ prevPath }),
    theme: 'light',
    setTheme: theme => set({ theme }),
    globalData: null,
    setGlobalData: globalData => set({ globalData }),
    currentPageData: null,
    setCurrentPageData: currentPageData => set({ currentPageData }),
    pageIsTransitioning: false,
    setPageIsTransitioning: pageIsTransitioning => set({ pageIsTransitioning }),
    enableInteraction: true,
    setEnableInteraction: enableInteraction => set({ enableInteraction }),
    remValueCalculated: false,
    setRemValueCalculated: remValueCalculated => set({ remValueCalculated }),
    bodyHeightChangeKey: null,
    setBodyHeightChangeKey: bodyHeightChangeKey => set({ bodyHeightChangeKey }),
    fontsLoaded: null,
    setFontsLoaded: fontsLoaded => set({ fontsLoaded }),
    forceEnableScrollDisabler: false,
    setForceEnableScrollDisabler: forceEnableScrollDisabler => set({ forceEnableScrollDisabler }),
    debugMobileText: false,
    setDebugMobileText: (debugMobileText, stack) => {
      if (stack) {
        const currentMobileText = useStore.getState().debugMobileText
        return set({
          debugMobileText: `
          ${currentMobileText}<br/>
          ${debugMobileText}
        `,
        })
      }

      return set({ debugMobileText })
    },

    // Preloader
    loaderAnimationComplete: process.env.NEXT_PUBLIC_DISABLE_PRELOADER === 'true' ? true : false,
    setLoaderAnimationComplete: loaderAnimationComplete => set({ loaderAnimationComplete }),
    showMainContent: process.env.NEXT_PUBLIC_DISABLE_PRELOADER === 'true' ? true : false,
    setShowMainContent: showMainContent => set({ showMainContent }),

    // Navigation
    navIsOpen: false,
    setNavIsOpen: navIsOpen => set({ navIsOpen }),

    // Product Gallery Nav
    productGalleryType: 'grid',
    setProductGalleryType: productGalleryType => set({ productGalleryType }),
    productGalleryTransitioning: false,
    setProductGalleryTransitioning: productGalleryTransitioning => set({ productGalleryTransitioning }),
    productGalleryProducts: [],
    setProductGalleryProducts: productGalleryProducts => set({ productGalleryProducts }),
    productGalleryFilters: [],
    setProductGalleryFilters: productGalleryFilters => set({ productGalleryFilters }),
    productGalleryActiveFilter: null,
    setProductGalleryActiveFilter: productGalleryActiveFilter => set({ productGalleryActiveFilter }),
    productGalleryActiveProductData: null,
    setProductGalleryActiveProductData: productGalleryActiveProductData => set({ productGalleryActiveProductData }),
    allowProductGalleryListHover: null,
    setAllowProductGalleryListHover: allowProductGalleryListHover => set({ allowProductGalleryListHover }),

    // Product Page
    zoomImageOpen: false,
    setZoomImageOpen: zoomImageOpen => set({ zoomImageOpen }),
    productGalleryImagesOpen: false,
    setProductGalleryImagesOpen: productGalleryImagesOpen => set({ productGalleryImagesOpen }),
    productPageData: null,
    setProductPageData: productPageData => set({ productPageData }),
    productPageActiveImage: null,
    setProductPageActiveImage: productPageActiveImage => set({ productPageActiveImage }),
    nextImage: null,
    setNextImage: nextImage => set({ nextImage }),
    nextImageCoords: { x: 0, y: 0, width: 0, height: 0, sanityImageBreakpoints: null },
    setNextImageCoords: nextImageCoords => set({ nextImageCoords }),

    // Cursor
    cursorState: null, // null, 'FOCUS', customText
    setCursorState: cursorState => set({ cursorState }),
    cursorPosition: { x: 0, y: 0 },
    setCursorPosition: cursorPosition => set({ cursorPosition }),
  })),
)

export default useStore
